var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("FinalizarProgramacionesDelMinisterio"),
      _vm._v(" "),
      _c("InformacionProgramacionDelMinisterio"),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "h3",
            { staticClass: "primary--text" },
            [
              _c("v-icon", { attrs: { color: "primary" } }, [_vm._v("event")]),
              _vm._v(" Programación de vacaciones\n    ")
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            [
              _c("v-data-table", {
                staticClass: "elevation-1 tabla-comprimida-light",
                attrs: {
                  items: _vm.lista_gestiones,
                  "hide-actions": "",
                  headers: _vm.headers
                },
                scopedSlots: _vm._u([
                  {
                    key: "items",
                    fn: function(props) {
                      return [
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(props.item.gestion))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm
                                  .$moment(props.item.fecha_inicio)
                                  .format("DD/MM/YYYY")
                              ) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm
                                  .$moment(props.item.fecha_fin)
                                  .format("DD/MM/YYYY")
                              ) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm
                                  .$moment(props.item.fecha_corte)
                                  .format("DD/MM/YYYY")
                              ) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                props.item.fecha_ampliacion
                                  ? _vm
                                      .$moment(props.item.fecha_ampliacion)
                                      .format("DD/MM/YYYY")
                                  : ""
                              ) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(props.item.porcentaje) + "%")
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "nowrap text-xs-center" },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  color: "info",
                                  to:
                                    "/vacaciones-listado-unidades/" +
                                    props.item.gestion,
                                  icon: "",
                                  title: "Ver programaciones de vacación"
                                }
                              },
                              [_c("v-icon", [_vm._v("remove_red_eye")])],
                              1
                            ),
                            _vm._v(" "),
                            props.item.id_estado != 72
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      color: "indigo",
                                      icon: "",
                                      dark: "",
                                      title: "Finalización de programación RRHH"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.finalizarProgramacionesDelMinisterio(
                                          props.item
                                        )
                                      }
                                    }
                                  },
                                  [_c("v-icon", [_vm._v("done")])],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            props.item.id_estado == 72
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      color: "rgba( 89, 184, 34,0.3)",
                                      icon: "",
                                      title:
                                        "Comprobante: finalización de programación"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.informacionProgramacionesDelMinisterio(
                                          props.item,
                                          props.item.comprobante
                                        )
                                      }
                                    }
                                  },
                                  [_c("v-icon", [_vm._v("receipt")])],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5ad735cf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ad735cf","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/vacacion_rrhh/VacacionesGestionRRHH.vue
// module id = null
// module chunks = 